import { AddDocumentTypeComponent } from './add-document-type-list/add-document-type/add-document-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentTypeComponent } from './document-type.component';
import { DocumentTypeRoutingModule } from './document-type-routing.module';
import { AddDocumentTypeListComponent } from './add-document-type-list/add-document-type-list.component';
import { HttpClientModule } from '@angular/common/http';
import { UpdateDocumentTypeComponent } from './update-document-type/update-document-type.component';
import { NzTreeSelectModule, NZ_ICONS, NgZorroAntdModule } from 'ng-zorro-antd';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';


const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key]);
@NgModule({
  declarations: [
    DocumentTypeComponent,
    AddDocumentTypeListComponent,
    AddDocumentTypeComponent,
    UpdateDocumentTypeComponent
  ],
  imports: [
    CommonModule,
    DocumentTypeRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    NgZorroAntdModule
  ],
  entryComponents: [
    AddDocumentTypeComponent,
    UpdateDocumentTypeComponent
  ],
  providers   : [ { provide: NZ_ICONS, useValue: icons } ]
})
export class DocumentTypeModule { }
